import { useState, useCallback } from 'react';
import { FilterConfig } from '@/shared/types/table';

export const useTableFilter = (initialFilters: FilterConfig[] = []) => {
  const [filters, setFilters] = useState<FilterConfig[]>(initialFilters);
  const [searchQuery, setSearchQuery] = useState('');

  const addFilter = useCallback((filter: FilterConfig) => {
    setFilters((prev) => {
      const existingIndex = prev.findIndex((f) => f.columnId === filter.columnId);
      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = filter;
        return updated;
      }
      return [...prev, filter];
    });
  }, []);

  const removeFilter = useCallback((columnId: string) => {
    setFilters((prev) => prev.filter((f) => f.columnId !== columnId));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters([]);
    setSearchQuery('');
  }, []);

  const updateFilter = useCallback((columnId: string, updates: Partial<FilterConfig>) => {
    setFilters((prev) => prev.map((f) => (f.columnId === columnId ? { ...f, ...updates } : f)));
  }, []);

  const hasActiveFilters = filters.length > 0 || searchQuery.length > 0;

  return {
    filters,
    searchQuery,
    setSearchQuery,
    addFilter,
    removeFilter,
    clearFilters,
    updateFilter,
    hasActiveFilters,
  };
};
